import { withInstall } from '@antdv/utils';
import AResult from './src/Result';

export const Result = withInstall(AResult);

export default Result;

export * from './src/interface';
export * from './src/props';
